import { EmissionApiAbstractHandler } from './EmissionApiAbstractHandler'
import useTryAgainModal from '../../../composables/useTryAgainModal'
import { ChainTarget } from '../../../domain/ChainOfResponsibility/Handler'
import { useModalControl } from '@/SignaturePlugin/A1/store/pinia/useModalControl.store'

export class ReturnUnknownErrors extends EmissionApiAbstractHandler {
  public async handle(target: ChainTarget): Promise<any> {
    const canProceed =
      target?.response?.status >= 200 && target?.response?.status < 300

    if (canProceed) {
      return super.handle(target)
    }

    return ReturnUnknownErrors.showTryAgainModal(target)
  }

  public static async showTryAgainModal(target: ChainTarget): Promise<void> {
    const tryAgainModal = useTryAgainModal()
    const modalControlStore = useModalControl()

    const backendMessage =
      target?.response?.data?.message ||
      target?.response?.data?.data?.message ||
      target?.response?.data?.mensagem ||
      ''

    if (backendMessage) {
      tryAgainModal.setTryAgainModalMessage(backendMessage)
    }

    tryAgainModal.setTryAgainModalAction(() => {
      const { _response, ...targetWithoutResponse } = target
      const handle = EmissionApiAbstractHandler.firstChainLink?.handle(
        targetWithoutResponse,
      )
      return handle
    })

    await modalControlStore.show({
      modalId: 'tryAgainModal',
      show: tryAgainModal.showTryAgainModal,
      hide: tryAgainModal.hideTryAgainModal,
    })
  }
}

export default ReturnUnknownErrors
